module.exports = __webpack_public_path__ + "static/media/decor5.66ca432f.jpg";